import { useMutation } from "@tanstack/react-query";
import { axiosInstance } from "../../axios";
//TODO Add type
const enquireQuote = async (data: any) => {
  return await axiosInstance
    .patch("quotes/enquire", data)
    .then((res) => res.data)
    .catch((e) => {
      throw e;
    });
};

const useEnquireQuoteMutation = () => {
  return useMutation({
    mutationFn: (data) => enquireQuote(data),
    mutationKey: ["quotes"],
  });
};

export default useEnquireQuoteMutation;
